"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RNShare = {
    open: async () => { },
};
exports.default = RNShare;
